module.exports = "<div #publicationVideoElementContainer\r\n     class=\"publication-video-element-container\">\r\n</div>\r\n"